import { render } from "./loading-modal-component.vue?vue&type=template&id=7f7ff834"
import script from "./loading-modal-component.vue?vue&type=script&lang=js"
export * from "./loading-modal-component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__